import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { ENDPOINT_PATH } from '../../../../config/paths';
import EndpointDeleteButton from './EndpointDeleteButton';

const EndpointToolbar = ({ endpointId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton path={`${ENDPOINT_PATH}/${endpointId}/edit`} />{' '}
      <EndpointDeleteButton endpointId={endpointId} />
    </div>
  </ButtonToolbar>
);

EndpointToolbar.propTypes = {
  endpointId: PropTypes.number.isRequired,
};

export default EndpointToolbar;